var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "files-list" },
    _vm._l(_vm.files, function (file, idx) {
      return _c("FileRow", {
        key: file.localId,
        attrs: { file: file, "is-last": idx === _vm.files.length - 1 },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }